<template>
	<div class="tool-card">
		<div class="tool-card__close" @click="$emit('close')">
			&times;
		</div>
		<h6 class="mb-0">Тип кисти:</h6>
		<h6 class="mb-2">{{currentBrush.title}}</h6>
		<div class="brushes">
			<label
				v-for="item in brushTypes"
				:key="item.name"
				@change="changeBrushType"
				:title="item.title"
			>
				<input
					type="radio"
					name="test"
					:value="item.name"
					v-model="currentBrushType"
				/>
				<img :src="item.img" alt="" />
			</label>
		</div>
		
		<p class="text-small" v-if="currentBrushType==='texturePatternBrush'">
			Выберите текстуру из каталога изображений 
		</p>

		<h6 class="mb-2">
			Толщина кисти: {{ valueBrush }}
		</h6>
		<b-form-input
			id="range-1"
			v-model="valueBrush"
			type="range"
			min="1"
			:maxValueBrush="maxValueBrush"
			@input="updateWidthBrush"
		></b-form-input>

	</div>

    <!-- <b-card>
        <h5>Настройки кистей</h5>
        <div class="row mb-4">
            <div class="col-12">
                <h6 class="mb-2">Тип кисти: {{currentBrush.title}}</h6>
				
                <div class="brushes">
                    <label
                        v-for="item in brushTypes"
                        :key="item.name"
                        @change="changeBrushType"
						:title="item.title"
                    >
                        <input
                            type="radio"
                            name="test"
                            :value="item.name"
                            v-model="currentBrushType"
                        />
                        <img :src="item.img" alt="" />
                    </label>
                </div>
				
				<p v-if="currentBrushType==='texturePatternBrush'">
					Выберите текстуру из каталога изображений 
				</p>
              
            </div>
            <div class="col-4">
                <div class="mb-2">
                    Толщина кисти: {{ valueBrush }}
                </div>
                <b-form-input
                    id="range-1"
                    v-model="valueBrush"
                    type="range"
                    min="1"
                    :maxValueBrush="maxValueBrush"
                    @input="updateWidthBrush"
                ></b-form-input>
            </div>
            <div class="col-4"></div>
        </div>
        <b-button variant="danger" @click="$emit('close')">
            <b-icon
                icon="x-circle-fill"
                aria-hidden="true"
            ></b-icon>
            Закрыть режим рисования
        </b-button>
    </b-card> -->
</template>

<script>
import { fabric } from "fabric";
import img1 from "@/assets/brushes/pencil-brush-icon.png"
import img2 from "@/assets/brushes/spray-brush-icon.png"
import img3 from "@/assets/brushes/circle-brush-icon.png"
import img4 from "@/assets/brushes/pattern-brush-icon.png"
import img5 from "@/assets/brushes/square-brush-icon.png"
import img6 from "@/assets/brushes/diamond-brush-icon.png"
import img7 from "@/assets/brushes/vline-brush-icon.png"
import img8 from "@/assets/brushes/hline-brush-icon.png"

// import textureBrush from "@/assets/popular/logo.png"
// import textureBrush from "@/assets/gifs/fsdf342.gif"


export default {
    props:[
        'canvas',
		'colorBrush',
		"close",
		"currentImage",
		"changeTextureBrush"
    ],
    data(){
        return {
			valueBrush: 25,
			maxValueBrush: 150,
            currentBrushType: "PencilBrush",
			brushTypes: [
				{
					name: "PencilBrush",
					title:"Карандаш",
					img: img1,
				},
				{
					name: "SprayBrush",
					title:"Спрей",
					img: img2
				},
				{
					name: "CircleBrush",
					title:"Круги",
					img: img3
				},
				{
					name: "PatternBrush",
					title:"Горошек",
					img: img4
				},
				{
					name: "squarePatternBrush",
					title:"Клетка",
					img: img5
				},
				{
					name: "diamondPatternBrush",
					title:"Диаманты",
					img: img6
				},
				{
					name: "vLinePatternBrush",
					title:"Вертикальные линии",
					img: img7
				},
				{
					name: "hLinePatternBrush",
					title:"Горизонтальные линии",
					img: img8
				},
				{
					name: "texturePatternBrush",
					title:"Своя текстура",
					img: img8
				},
				// "texturePatternBrush",
			],
        }
    },
	computed:{
		currentBrush(){
			return this.brushTypes.find(item => item.name === this.currentBrushType)
		}
	},
	watch:{
		currentImage: function(){
			console.log("currentImage chenged")
			this.brushTypes[this.brushTypes.length - 1].img = this.currentImage;
			this.changeBrushType()
		}
	},
	created(){
		console.log("brushes created")
		this.changeBrushType()
	},
	mounted(){
		this.brushTypes[this.brushTypes.length - 1].img = this.currentImage
	},
    methods:{
        updateColorBrush() {
			// console.log(this.colorBrush);
			let brush = this.canvas.freeDrawingBrush;
			brush.color = this.colorBrush;
			if (brush.getPatternSrc) {
				brush.source = brush.getPatternSrc.call(brush);
			}
			// let selected = this.canvas.getActiveObject()
			// if(selected){
			// 	selected.set("stroke",brush.color)
			// }
		},
        updateWidthBrush() {
			console.log(this.valueBrush);
			this.canvas.freeDrawingBrush.width =
				parseInt(this.valueBrush, 10) || 1;
		},
        changeBrushType() {
			this.$emit('changeTextureBrush',false);

			switch (this.currentBrushType) {
				case "hLinePatternBrush":
					this.hLinePatternBrush();
					break;
				case "vLinePatternBrush":
					this.vLinePatternBrush();
					break;
				case "squarePatternBrush":
					this.squarePatternBrush();
					break;
				case "diamondPatternBrush":
					this.diamondPatternBrush();
					break;
				case "texturePatternBrush":
					this.texturePatternBrush();
					break;
				default:
					this.canvas.freeDrawingBrush = new fabric[
						this.currentBrushType
					](this.canvas);
					break;
			}

			if (this.canvas.freeDrawingBrush) {
				var brush = this.canvas.freeDrawingBrush;
				brush.color = this.colorBrush;
				if (brush.getPatternSrc) {
					brush.source = brush.getPatternSrc.call(brush);
				}
				brush.width = parseInt(this.valueBrush, 10) || 1;
				brush.shadow = new fabric.Shadow({
					blur: parseInt(this.valueShadowBlur, 10) || 0,
					offsetX: 0,
					offsetY: 0,
					affectStroke: true,
					color: this.colorShadow,
				});
			}
			console.log(this.currentBrushType);
		},
        vLinePatternBrush() {
			let vLinePatternBrush = new fabric.PatternBrush(this.canvas);
			vLinePatternBrush.getPatternSrc = () => {
				let patternCanvas = fabric.document.createElement("canvas");
				patternCanvas.width = patternCanvas.height = 10;
				let ctx = patternCanvas.getContext("2d");

				ctx.strokeStyle = this.colorBrush;
				ctx.lineWidth = 5;
				ctx.beginPath();
				ctx.moveTo(0, 5);
				ctx.lineTo(10, 5);
				ctx.closePath();
				ctx.stroke();

				return patternCanvas;
			};
			this.canvas.freeDrawingBrush = vLinePatternBrush;
		},
		hLinePatternBrush() {
			let hLinePatternBrush = new fabric.PatternBrush(this.canvas);
			hLinePatternBrush.getPatternSrc = () => {
				let patternCanvas = fabric.document.createElement("canvas");
				patternCanvas.width = patternCanvas.height = 10;
				let ctx = patternCanvas.getContext("2d");

				ctx.strokeStyle = this.colorBrush;
				ctx.lineWidth = 5;
				ctx.beginPath();
				ctx.moveTo(5, 0);
				ctx.lineTo(5, 10);
				ctx.closePath();
				ctx.stroke();
				return patternCanvas;
			};
			this.canvas.freeDrawingBrush = hLinePatternBrush;
		},
		squarePatternBrush() {
			let squarePatternBrush = new fabric.PatternBrush(this.canvas);
			squarePatternBrush.getPatternSrc = () => {
				let squareWidth = 10,
					squareDistance = 2;

				let patternCanvas = fabric.document.createElement("canvas");
				patternCanvas.width = patternCanvas.height =
					squareWidth + squareDistance;
				let ctx = patternCanvas.getContext("2d");

				ctx.fillStyle = this.colorBrush;
				ctx.fillRect(0, 0, squareWidth, squareWidth);
				return patternCanvas;
			};
			this.canvas.freeDrawingBrush = squarePatternBrush;
		},
		diamondPatternBrush() {
			var diamondPatternBrush = new fabric.PatternBrush(this.canvas);
			diamondPatternBrush.getPatternSrc = () => {
				var squareWidth = 10,
					squareDistance = 5;
				var patternCanvas = fabric.document.createElement("canvas");
				var rect = new fabric.Rect({
					width: squareWidth,
					height: squareWidth,
					angle: 45,
					fill: this.colorBrush,
				});

				var canvasWidth = rect.getBoundingRect().width;

				patternCanvas.width = patternCanvas.height =
					canvasWidth + squareDistance;
				rect.set({ left: canvasWidth / 2, top: canvasWidth / 2 });

				var ctx = patternCanvas.getContext("2d");
				rect.render(ctx);

				return patternCanvas;
			};
			this.canvas.freeDrawingBrush = diamondPatternBrush;
		},
        texturePatternBrush() {
			this.$emit('changeTextureBrush',true);
			console.log("texturePatternBrush method")
			// let texture = new Image();
			// texture.onload = ()=>{
			// 	let texturePatternBrush = new fabric.PatternBrush(this.canvas);
			// 	// image  has been loaded
			// 	console.log(textureBrush)
			// 	texture.src = 'http://upload.wikimedia.org/wikipedia/en/3/35/Starbucks_Coffee_Logo.svg';
			// 	texturePatternBrush.source = texture;
			// 	texturePatternBrush.width = this.valueBrush;
			// 	texturePatternBrush.height = this.valueBrush;

			// 	// texturePatternBrush.source = texture;

			// 	this.canvas.freeDrawingBrush = texturePatternBrush;
			// 	};
			const img = new Image();
			img.onload = ()=> {
				var texturePatternBrush = new fabric.PatternBrush(this.canvas);
				// is it possible to also scale the image here?
				texturePatternBrush.source = img;
				// texturePatternBrush.scale(0.5);
				texturePatternBrush.width = this.valueBrush;
				texturePatternBrush.height = this.valueBrush;
				this.canvas.freeDrawingBrush = texturePatternBrush;
			};
			img.src = this.currentImage;
		
		},
		// isSelectedTexture(texture) {
		// 	return texture === this.image ? "selected" : "";
		// },
		// selectTextureImage(img) {
		// 	this.image = img;
		// 	this.texturePatternBrush();
		// },
		// inputTexturePatternImage(file) {
		// 	this.textureImageSrc = URL.createObjectURL(file);
		// 	this.texturePatternBrush();
		// 	this.textures.push(this.textureImageSrc);
		// },
    }
}
</script>

<style>

</style>